import React, {useMemo} from "react";

import {useEthereum} from "../../EthereumContext";
import Modal from "../Interface/Modal/Modal";
import Input from "../Interface/Input/Input";
import Button from "../Interface/Button/Button";
import {toast} from "react-toastify";
import ProcessingLabel from "../Interface/ProcessingLabel";
import { useFetchGovTokenData } from '../../redux/hooks/useFetchGovTokenData';
import useResize from "../../hooks/useResize";

function DelegationModal({isOpen, setIsOpen}) {
    const {xRoobee, account} = useEthereum();

    const [delegate, setDelegate] = React.useState("");
    const [pending, setPending] = React.useState(false);

    const [showLoading, setShowLoading] = React.useState(false);
    const [status, setStatus] = React.useState("");

    const { fetchGovToken } = useFetchGovTokenData();

    const onDelegate = async () => {
        setPending(true);
        showProcessingLoader("Delegating votes");
        try {
            const tx = await xRoobee.delegate(delegate, {gasLimit: 2000000});
            await tx.wait();
            toast.info("Delegation is completed");
            setIsOpen(false);
            fetchGovToken();
        } catch(err) {
            toast.error("Delegation failed");
        } finally {
            setPending(false);
            hideProcessingLoader();
        }
    };

    const showProcessingLoader = React.useCallback((status) => {
        setStatus(status);
        setShowLoading(true);
    }, [setShowLoading, setStatus]);

    const hideProcessingLoader = React.useCallback(() => {
        setStatus("");
        setShowLoading(false);
    }, [setShowLoading, setStatus]);

    const { windowWidth } = useResize();

    const mobileView = useMemo(() => windowWidth <= 600, [windowWidth]);

    return (
        <Modal
            title="Delegate Voting"
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            height={310}
        >
            <div>
                <ProcessingLabel
                    show={showLoading && status !== ''}
                    message={status}
                />
                <div style={
                    mobileView ?
                        {marginTop: 30, paddingLeft: 20, paddingRight: 20}
                        :
                        {marginTop: 40, paddingLeft: 100, paddingRight: 100}}
                >
                    <div style={{display: "flex", justifyContent: "space-between"}}>
                        <span style={{color: "var(--grey0)"}}>Delegate Address</span>
                        <span
                            style={{color: "var(--grey0)", cursor: "pointer"}}
                            onClick={() => setDelegate(account)}
                        >
                            Me
                        </span>
                    </div>
                    <Input
                        value={delegate}
                        setValue={setDelegate}
                        style={{marginTop: 5}}
                        placeholder="Enter address"
                    />
                    <div style={{width: "100%", display: "flex", flexDirection: "column", alignItems: "center", marginTop: 40}}>
                        <Button className="highlightedButton" onClick={onDelegate} blinking={pending} disabled={pending}>
                            Delegate Votes
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default DelegationModal;
